import membershipsGuard from './memberships.guard';
import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'router' ].join('/');
const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {import('./memberships.guard').GuardOpts} RouterOpts
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {RouterOpts} opts
   */
  install (Vue, opts) {
    log('installing with opts', opts);
    Vue.use(membershipsGuard, opts);
  }
};
